import { memo } from 'react';
import { Search } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Input } from '../ui/input';
import { useLocation } from 'react-router-dom';

type SearchBarProps = {
  innerRef: React.RefObject<HTMLInputElement>;
  isFocused: boolean;
  setIsFocused: (value: boolean) => void;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
};

export const SearchBar = memo<SearchBarProps>(
  ({ innerRef, isFocused, setIsFocused, value, onChange, onSearch }) => {
    const location = useLocation();
    const shouldHide = ['/', '/login', '/register'].includes(location.pathname);

    if (shouldHide) {
      return null;
    }

    return (
      <div className="relative">
        <Search
          className={cn(
            'absolute left-2.5 top-2.5 h-4 w-4 transition-colors',
            isFocused ? 'text-primary' : 'text-muted-foreground',
          )}
          aria-hidden="true"
        />
        <Input
          ref={innerRef}
          type="text"
          value={value}
          onChange={onChange}
          onKeyDown={(e) => e.key === 'Enter' && onSearch()}
          placeholder="Search by Address / Tx Hash"
          className={cn(
            'w-full pl-8 transition-all focus-visible:ring-0 [&:focus]:border-input',
          )}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          aria-label="Search by Address or Transaction Hash"
        />
        {!isFocused && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            <kbd className="rounded-sm bg-gray-500 bg-opacity-25 px-2 py-0.5 text-sm font-bold text-white">
              /
            </kbd>
          </div>
        )}
      </div>
    );
  },
);

SearchBar.displayName = 'SearchBar';
